import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { BookOpen, Bot } from "lucide-react";

const Tabs = ({ tabs, paramKey = "tab" }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get(paramKey) || tabs[0].key;
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    searchParams.set(paramKey, activeTab);
    setSearchParams(searchParams);
  }, [activeTab, paramKey, searchParams, setSearchParams]);

  const handleTabClick = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="w-full">
      <div className="flex bg-gray-100 rounded-lg p-0.5 shadow-sm">
        {tabs.map((tab, index) => (
          <button
            key={tab.key}
            onClick={() => handleTabClick(tab.key)}
            className={`flex items-center gap-1.5 px-3 py-2 transition-all flex-1 justify-center font-semibold text-gray-700 ${
              activeTab === tab.key
                ? "bg-white text-gray-900 rounded-l-lg rounded-r-lg"
                : "text-gray-700 hover:text-gray-800"
            } ${
              index === 0 && activeTab === tab.key ? "rounded-l-lg" : ""
            } ${
              index === tabs.length - 1 && activeTab === tab.key ? "rounded-r-lg" : ""
            } ${
              index === 0 && activeTab !== tab.key ? "rounded-l-lg" : ""
            } ${
              index === tabs.length - 1 && activeTab !== tab.key ? "rounded-r-lg" : ""
            }`}
          >
            {tab.icon && <tab.icon className="w-4 h-4" />}
            {tab.label}
          </button>
        ))}
      </div>

      <div className="mt-4">
        {tabs.map((tab) =>
          activeTab === tab.key ? <div key={tab.key}>{tab.content}</div> : null
        )}
      </div>
    </div>
  );
};

export default Tabs;
